import { Switch } from 'components/DesignSystem/Switch';

export const CriticalPathFilter = ({ value, setValue }) => {
    return (
        <div>
            <Switch
                checked={value}
                onChange={() => {
                    setValue('criticalPath', !value);
                }}
                label={'Critical Path Only'}
                labelPlacement={'start'}
            />
        </div>
    );
};
